import { PatrimoineService } from '@lib/components/investisseur-details/tabs/connaissance-client/steps/patrimoine-step/patrimoine.service';
import { SubCategoryEnum } from '@lib/models/generated/graphql';
import { of } from 'rxjs';
import { fullComparator, inOperator } from '../../filtre-investisseur-helper';
import { CompositeFiltreCustomBuilder, FiltreBuilder } from '../filtre-builder.model';

export function getImmoBuilders(patrimoineService: PatrimoineService): FiltreBuilder[] {
  return [
    new CompositeFiltreCustomBuilder(
      'IMMO',
      'PATRIMOINE_IMMOBILIER_MODE_DETENTION',
      'investisseurPatrimoines.some.and',
      'patrimoine.patrimoineActif.modeDetention',
      inOperator,
      'SelectMultiple',
      of(patrimoineService.modeDetentionOption),
      [{ fieldPath: 'patrimoine.patrimoineCategorie.subCategory', operator: 'eq', value: SubCategoryEnum.Immobilier }]
    ),
    new CompositeFiltreCustomBuilder(
      'IMMO',
      'PATRIMOINE_IMMOBILIER_DATE_ACQUISITION',
      'investisseurPatrimoines.some.and',
      'patrimoine.patrimoineActif.dateAcquisition',
      fullComparator,
      'DateTime',
      undefined,
      [{ fieldPath: 'patrimoine.patrimoineCategorie.subCategory', operator: 'eq', value: SubCategoryEnum.Immobilier }]
    ),
  ];
}
